document.addEventListener('DOMContentLoaded', function() {
    const targetNodeDesktop = document.querySelector('#FacetsWrapperDesktop');
    const targetNodeMobile = document.querySelector('#FacetsWrapperMobile');
    const observerOptions = {
        childList: true,
        attributes: true,
        subtree: true
    };

    const observerCallback = function(mutationsList, observer) {
        for (let mutation of mutationsList) {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                let hideLabel = document.querySelector('.button-label.hide-filter');
                let showLabel = document.querySelector('.button-label.open-filter');
                const facetsWrapper = document.querySelector('aside.facets-wrapper');
    
                if (facetsWrapper.classList.contains('show')) {
                    if (hideLabel) {
                        hideLabel.classList.add('show');
                    }
                    if (showLabel) {
                        showLabel.classList.remove('show');
                    }
                } else {
                    if (hideLabel) {
                        hideLabel.classList.remove('show');
                    }
                    if (showLabel) {
                        showLabel.classList.add('show');
                    }
                }
                
                hideLabel = document.querySelector('.button-label.hide-filter.show');
                if (hideLabel) {
                    hideLabel.addEventListener('click', function() {
                        hideLabel.classList.remove('show');
                        if (showLabel) {
                            showLabel.classList.add('show');
                        }
                    });
                }
    
                updateToggleButton();
                checkFacetsWrapperVisibility();
            }
        }
    };
    

    const observer = new MutationObserver(observerCallback);

    // Check desktop
    if (targetNodeDesktop) {
        observer.observe(targetNodeDesktop, observerOptions);
    }

    // Check mobile
    if (targetNodeMobile) {
        observer.observe(targetNodeMobile, observerOptions);
    }

    const toggleButton = document.querySelector('.mobile-facets__open-wrapper');
    const hideLabel = document.querySelector('.button-label.hide-filter');
    const showLabel = document.querySelector('.button-label.open-filter');
    const facetsWrapper = document.querySelector('aside.facets-wrapper');
    const filterIcon = document.querySelector('.mobile-facets__open svg');
    
    function initializeGridState() {
        const isFilterOpen = facetsWrapper.classList.contains('show');
        const productGrid = document.querySelector('#product-grid');
        
        if (isFilterOpen) {
            hideLabel.classList.add('show');
            showLabel.classList.remove('show');
            
            if (productGrid) {
                productGrid.classList.remove('filters-closed');
                productGrid.classList.add('filters-open');
            }
        } else {
            hideLabel.classList.remove('show');
            showLabel.classList.add('show');
            
            if (productGrid) {
                productGrid.classList.remove('filters-open');
                productGrid.classList.add('filters-closed');
            }
        }
    }
    setTimeout(initializeGridState, 100);
    
    toggleButton.addEventListener('click', function () {
        const isVisible = facetsWrapper.classList.toggle('show'); // Alternar a visibilidade do aside
        const productGrid = document.querySelector('#product-grid');
        
        if (isVisible) {
            // Mostrar o estado "Hide filters"
            hideLabel.classList.add('show');
            showLabel.classList.remove('show');
            
            // Aplicar classe para grid de 4 colunas (filtros abertos)
            if (productGrid) {
                productGrid.classList.remove('filters-closed');
                productGrid.classList.add('filters-open');
            }
        } else {
            // Mostrar o estado "Show filters"
            hideLabel.classList.remove('show');
            showLabel.classList.add('show');
            
            // Aplicar classe para grid de 5 colunas (filtros fechados)
            if (productGrid) {
                productGrid.classList.remove('filters-open');
                productGrid.classList.add('filters-closed');
            }
        }
    });
    

    function updateToggleButton() {
        const isVisible = facetsWrapper.classList.contains('show');
        const productGrid = document.querySelector('#product-grid');
        
        if (isVisible) {
            hideLabel.classList.add('show');
            showLabel.classList.remove('show');
            
            // Aplicar classe para grid de 4 colunas (filtros abertos)
            if (productGrid) {
                productGrid.classList.remove('filters-closed');
                productGrid.classList.add('filters-open');
            }
        } else {
            hideLabel.classList.remove('show');
            showLabel.classList.add('show');
            
            // Aplicar classe para grid de 5 colunas (filtros fechados)
            if (productGrid) {
                productGrid.classList.remove('filters-open');
                productGrid.classList.add('filters-closed');
            }
        }
    }

    // Adicionar listener para redimensionamento da janela
    window.addEventListener('resize', function() {
        updateToggleButton();
    });
    
    function checkFacetsWrapperVisibility() {
        let minPriceInput, maxPriceInput;
        if(innerWidth < 979){
            const a = document.querySelector('.slider-container.desktop-slider')
            if (a) {
                a.remove();
            }
            // Inputs  mobile
            minPriceInput = document.getElementById('Mobile-Filter-Price-GTE');
            maxPriceInput = document.getElementById('Mobile-Filter-Price-LTE');
        } else {
            const a = document.querySelector('.slider-container.mobile-slider')
            if (a) {
                a.remove();
            }
            // Inputs  desktop
            minPriceInput = document.getElementById('Filter-Price-GTE');
            maxPriceInput = document.getElementById('Filter-Price-LTE');
        }

        const minSlider = document.getElementById('minSlider');
        const maxSlider = document.getElementById('maxSlider');
        const minValue = document.getElementById('minValue');
        const maxValue = document.getElementById('maxValue');

        function formatToDecimal(value) {
            return (Number(value) / 100);
        }

        const currencyCode = window.Shopify.currency.active;
        const locale = window.Shopify.locale;

        minSlider.addEventListener('input', () => {
            if (parseInt(minSlider.value) > parseInt(maxSlider.value)) {
                minSlider.value = maxSlider.value;
            }
            const formattedMinValue = formatToDecimal(minSlider.value).toLocaleString(locale, { style: 'currency', currency: currencyCode });
            minValue.textContent = formattedMinValue;
            if (minPriceInput) {
                minPriceInput.value = formattedMinValue;
            }
        });

        maxSlider.addEventListener('input', () => {
            if (parseInt(maxSlider.value) < parseInt(minSlider.value)) {
                maxSlider.value = minSlider.value;
            }
            const formattedMaxValue = formatToDecimal(maxSlider.value).toLocaleString(locale, { style: 'currency', currency: currencyCode });
            maxValue.textContent = formattedMaxValue;
            if (maxPriceInput) {
                maxPriceInput.value = formattedMaxValue;
            }
        });
    }

    if(innerWidth < 979){
        checkFacetsWrapperVisibility();
    }

    // Resize
    window.addEventListener('resize', checkFacetsWrapperVisibility);


    //close mobile filter
    const closeMobileFilter = document.querySelector('.close-filter-mob');
    if (closeMobileFilter) {
        closeMobileFilter.addEventListener('click', function() {
            const disclosure = document.querySelector('.mobile-facets__disclosure');
            if (disclosure) {
                disclosure.classList.remove('menu-opening');
                disclosure.removeAttribute('open');
            }
            const body = document.querySelector('body');
            if (body) {
                body.classList.remove('overflow-hidden-mobile');
            }
        });
    }

});
